"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

type ConfettiCampaigns = Record<string, number>;

interface ConfettiStoreState {
  campaigns: ConfettiCampaigns;
  markCampaign: (campaignName: string, nextWindowDate: number) => void;
  clearCampaign: (campaignName: string) => void;
}

export const useConfettiStore = create<ConfettiStoreState>()(
  persist(
    (set) => ({
      campaigns: {},
      markCampaign: (campaignName, nextWindowDate) =>
        set((state) => ({
          campaigns: {
            ...state.campaigns,
            [campaignName]: nextWindowDate,
          },
        })),
      clearCampaign: (campaignName) =>
        set((state) => {
          const { [campaignName]: _removed, ...rest } = state.campaigns;
          return { campaigns: rest };
        }),
    }),
    {
      name: "epoch-confetti-store-v2",
    },
  ),
);
